import { render } from "./HomeTestimonies.vue?vue&type=template&id=57b8af1a&scoped=true&lang=html"
import script from "./HomeTestimonies.vue?vue&type=script&lang=js"
export * from "./HomeTestimonies.vue?vue&type=script&lang=js"

import "./HomeTestimonies.vue?vue&type=style&index=0&id=57b8af1a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b8af1a"]])

export default __exports__